<div class="flex items-center justify-center w-full md:p-4">
    <button mat-icon-button class="absolute top-2 right-2 " (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>
    Sua resposta foi recebida. Obrigado :)
</div>